<template >
  <ion-input v-model="model" clear-input :placeholder="placeholder" @ionChange="onInput"/>
</template>

<script>
  import { IonInput } from '@ionic/vue'
  import { createNamespacedHelpers, mapState } from 'vuex'
  const { mapMutations:registersMutations, mapActions:registersActions } = createNamespacedHelpers('registers')
  export default {
    name: 'VTextFieldAsync',
    components: {
      IonInput
    },
    props: {
      collection: {
        type: String,
        required: true
      },

      /**
       * Função de tratamento da requisição da busca.
       * Essa função será chamada recebendo como parâmetro a Promise da chamada da busca do algolia
       */
      handler: {
        type: Function,
        required: false
      },
      handlerLoading: {
        type: Function,
        required: false
      },

      /**
       * Valor em ms do intervalo de espera de parada de input até realizar a requisição.
       */
      delay: {
        type: Number,
        required: false,
        default: () => 0
      },

      placeholder: String,
      fieldsToSearch: Array,
      register: String,
      filters: Array,
      filtersIn: Array,
    },
    watch: {
      $route() {
        this.clear()
      },
      dispatchSearchingAsync({query, filters}) {
        this.search(query, filters)
      },
    },
    data() {
      return {
        timer: null,
        model: ''
      }
    },
    computed: {
      ...mapState(['dispatchSearchingAsync']),
      registerFiltered() {
        return `${this.register}Filtered`
      }
    },
    methods: {
      ...registersMutations(['resetRegister']),
      ...registersActions(['getOnMongo']),
      onInput(event) {
        const query = event.target.value
        if (this.delay)
          this.timeoutSearch(query, this.filters, this.filtersIn)
        else
          this.search(query, this.filters, this.filtersIn)
      },
      timeoutSearch(query, filters, filtersIn) {
        if (query || filters || filtersIn) {
          if (this.timer)
            clearTimeout(this.timer)
    
          this.timer = setTimeout(() => {
            this.timer = null
            this.handler(this.asyncSearch(query, filters, filtersIn))
          }, this.delay)
        } else {
          this.handler({query})
        }
      },
      search(query, filters, filtersIn) {
        if (query || filters?.length > 0 || filtersIn?.length > 0) {
          this.handler(this.asyncSearch(query, filters, filtersIn))
        }
      },
      clear() {
        this.model = ''
      },
      asyncSearch(query, filters, filtersIn) {
        this.handlerLoading(true)
        this.resetRegister(this.registerFiltered)
        const filtersInSelecteds = filtersIn ? filtersIn.filter(f => {return f.selecteds && f.selecteds.length > 0}) : []
        if (query || (filters && filters.length > 0) || (filtersInSelecteds && filtersInSelecteds.length > 0)) {
          // Replace especial chars
          if (query) query = query.replace(/\+|\/|\.|\(|\)/g, '')

          const orFilters = []
          if (query) {
            for (const header of this.fieldsToSearch) {
              orFilters.push({
                key: header.fill || header.value,
                operator: 'like',
                value: query
              })
            }
          }
      
          this.getOnMongo({
            register: this.registerFiltered, 
            collection: this.collection, 
            filters, 
            orFilters,
            orderBy: this.orderBy, 
            getTotal: true,
            onSnapshot: true,
            // forceFilter: true
          })
          .then(() => 
            setTimeout(() => {
              this.handlerLoading(false)
            }, 200)
          )
          .catch(err => this.handlerLoading(false))

          // Não precisa retornar o resultado pois o observer grava direto na vuex para manter a reatividade
          // Retorna query para controle de visualização no componente pai
          return {query} 
        }
        else {
          this.handlerLoading(false)
          return {query}
        }
      }
    }
  }
</script>